module.exports = __webpack_public_path__ + "static/media/arrow.e1dd3726.svg";